import { getEnsuredNumericInput } from '../selectors/inputs';
import { computeUserFootprint } from './computeResults';

export default () => (dispatch, getState) => {
  const state = getState();
  const numberVehicles = getEnsuredNumericInput(state, 'input_footprint_transportation_num_vehicles') + 1;
  computeUserFootprint({
    input_footprint_transportation_num_vehicles: numberVehicles,
  })(dispatch, getState);
};
